var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_5161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45088 1.50493L1.50951 7.4463C0.101702 8.85411 0.101702 11.1366 1.50951 12.5444L7.45088 18.4858C8.85869 19.8936 11.1412 19.8936 12.549 18.4858L18.4904 12.5444C19.8982 11.1366 19.8982 8.85411 18.4904 7.4463L12.549 1.50493C11.1412 0.0971235 8.85869 0.0971229 7.45088 1.50493Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45088 1.50493L1.50951 7.4463C0.101702 8.85411 0.101702 11.1366 1.50951 12.5444L7.45088 18.4858C8.85869 19.8936 11.1412 19.8936 12.549 18.4858L18.4904 12.5444C19.8982 11.1366 19.8982 8.85411 18.4904 7.4463L12.549 1.50493C11.1412 0.0971235 8.85869 0.0971229 7.45088 1.50493Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72754 7.57403L6.72754 12.4261C6.72754 12.8937 7.10658 13.2727 7.57415 13.2727L12.4262 13.2727C12.8938 13.2727 13.2728 12.8937 13.2728 12.4261L13.2728 7.57403C13.2728 7.10646 12.8938 6.72742 12.4262 6.72742L7.57415 6.72742C7.10658 6.72742 6.72754 7.10646 6.72754 7.57403Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_5161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenDashboard);
export default __webpack_public_path__ + "static/media/token_dashboard.f0cddc0035835d415c4bbfdd2cbcf141.svg";
export { ForwardRef as ReactComponent };